import { useEffect, useState, useRef } from "react";

export default function ControlBroadcastChannel(channelName = "externoNuevo") {
    const [isDuplicateTab, setIsDuplicateTab] = useState(false);
    const broadcastChannelRef = useRef<BroadcastChannel | null>(null);
  
    useEffect(() => {
      // 1. Crear canal de comunicación
      broadcastChannelRef.current = new BroadcastChannel(channelName);
  
      // 2. Escuchar mensajes que llegan a este canal
      broadcastChannelRef.current.onmessage = (event) => {
        if (event.data === "CHECK_TAB") {
          // Responder a la otra pestaña que esta pestaña ya está abierta
          broadcastChannelRef.current!.postMessage("TAB_ALREADY_OPEN");
        }
        if (event.data === "TAB_ALREADY_OPEN") {
          // Recibimos la notificación de que ya hay otra pestaña
          setIsDuplicateTab(true);
        }
      };
  
      // 3. Al montar el componente, preguntamos si hay otra pestaña
      broadcastChannelRef.current.postMessage("CHECK_TAB");
  
      return () => {
        if (broadcastChannelRef.current) {
          broadcastChannelRef.current.close();
        }
      };
    }, [channelName]);
  
    return isDuplicateTab;
}